<template>
  <div class="ordinaryModify custom">
    <el-dialog :popper-append-to-body="false" :close-on-click-modal="false" :visible.sync="diamondSelectDialogVisible" :before-close="handleClose">
      <div
        class="ordinaryModifyChild"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="secBox">
          <div class="child" v-if="handTextureList && handTextureList.length > 0">
            <div class="selb">
              <span class="selb-title">材质：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.texture" size="small" @change="getSizeRange($event, 'texture', 'texture')">
                  <span class="inchesFix" :class="[item.flag == true ? 'stockBg' : '']" v-for="item in handTextureList" :key="item.value">
                    <el-radio-button :value="item.value" :label="item.value">{{ item.value }}</el-radio-button>
                    <div class="outStore" v-if="item.flag == true">缺货</div>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="optionsList.gemNameList && optionsList.gemNameList.length > 0">
            <div class="selb">
              <span class="selb-title">辅石：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.gemName" size="small" @change="getSizeRange($event, 'gemName', 'assistStoneNameOne')">
                  <span class="inchesFix" :class="[item.flag == true ? 'stockBg' : '']" v-for="item in optionsList.gemNameList" :key="item.value">
                    <el-radio-button :value="item.value" :label="item.value">{{ item.value }}</el-radio-button>
                    <div class="outStore" v-if="item.flag == true">缺货</div>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="optionsList.formatTypes && optionsList.formatTypes.length > 0">
            <div class="selb">
              <span class="selb-title">版型：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.formatType" size="small" @change="getSizeRange($event, 'formatType', 'formatType')">
                  <span class="inchesFix" :class="[item.flag == true ? 'stockBg' : '']" v-for="item in optionsList.formatTypes" :key="item.value">
                    <el-radio-button :value="item.value" :label="item.value">{{ item.value }}</el-radio-button>
                    <div class="outStore" v-if="item.flag == true">缺货</div>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="mainStoneList && mainStoneList.length > 0">
            <div class="selb">
              <span class="selb-title">主石重量：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.mainStone" size="small" @change="getSizeRange($event, 'mainStone', 'mainStoneWeight')">
                  <span class="inchesFix" :class="[item.flag == true ? 'stockBg' : '']" v-for="item in mainStoneList" :key="item.value">
                    <el-radio-button :value="item.value" :label="item.value">{{ item.value }}</el-radio-button>
                    <div class="outStore" v-if="item.flag == true">缺货</div>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="optionsList.mainStoneClarity && optionsList.mainStoneClarity.length > 0">
            <div class="selb">
              <span class="selb-title">净度：</span>
              <div class="material selectBox">
                <el-radio-group
                  v-model="amendDuplication.mainStoneClarity"
                  size="small"
                  @change="getSizeRange($event, 'mainStoneClarity', 'mainStoneClarity')"
                >
                  <span
                    class="inchesFix"
                    :class="[item.flag == true ? 'stockBg' : '']"
                    v-for="item in optionsList.mainStoneClarity"
                    :key="item.value"
                  >
                    <el-radio-button :value="item.value" :label="item.value">{{ item.value | clarityColor }}</el-radio-button>
                    <div class="outStore" v-if="item.flag == true">缺货</div>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="optionsList.mainStoneColour && optionsList.mainStoneColour.length > 0">
            <div class="selb">
              <span class="selb-title">颜色：</span>
              <div class="material selectBox">
                <el-radio-group
                  v-model="amendDuplication.mainStoneColour"
                  size="small"
                  @change="getSizeRange($event, 'mainStoneColour', 'mainStoneColor')"
                >
                  <span class="inchesFix" :class="[item.flag == true ? 'stockBg' : '']" v-for="item in optionsList.mainStoneColour" :key="item.value">
                    <el-radio-button :value="item.value" :label="item.value">{{ item.value | clarityColor }}</el-radio-button>
                    <div class="outStore" v-if="item.flag == true">缺货</div>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="handSizeList && handSizeList.length > 0">
            <div class="selb">
              <span class="inchesTips-size" v-if="handSizeList && handSizeList[0].value.includes('寸')">(1英寸＝2.54厘米)</span>
              <span class="selb-title">规格：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.ringSize" size="small" @change="getSizeRange($event, 'ringSize', 'spec')">
                  <span class="inchesFix" :class="[item.flag == true ? 'stockBg' : '']" v-for="item in handSizeList" :key="item.value">
                    <el-radio-button :value="item.value" :label="item.value">{{ item.value }}</el-radio-button>
                    <div class="outStore" v-if="item.flag == true">缺货</div>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="optionsList.gia && optionsList.gia.length > 0 && product.productStructure != '一心一爱'">
            <div class="selb">
              <span class="selb-title">GIA：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.gia" size="small" @change="getSizeRange($event, 'gia', 'gia')">
                  <span class="inchesFix" :class="[item.flag == true ? 'stockBg' : '']" v-for="item in optionsList.gia" :key="item.value">
                    <el-radio-button :value="item.value" :label="item.value">{{ item.value | cutFilter }}</el-radio-button>
                    <div class="outStore" v-if="item.flag == true">缺货</div>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child">
            <div class="selb">
              <span class="selb-title">商品数量：</span>
              <el-input-number
                @keyup.enter.native="getSizeRange($event, 'quantity')"
                @input.native="onNative($event)"
                :min="product.leastQuantity"
                :max="amendDuplication.spotFlag == 2 ? 9999 : optionsList.stockQuantity"
                @change="getSizeRange($event, 'quantity')"
                v-model="amendDuplication.quantity"
              ></el-input-number>
              <span class="inchesTips" v-if="amendDuplication.spotFlag == 1">库存：{{ optionsList.stockQuantity || 0 }}件</span>
            </div>
          </div>
          <div class="child remorkBox">
            <div class="selb">
              <span class="selb-title">备注：</span>
              <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入内容" v-model="amendDuplication.productRemark"> </el-input>
            </div>
          </div>
          <div
            class="child"
            v-if="amendDuplication.tradePrice && hasPriceViewPermission()"
          >
            <div class="selb">
              <span class="selb-title">结算金额：</span>
              <span>{{ amendDuplication.tradePrice }}</span>
            </div>
          </div>
          <div class="child" v-if="amendDuplication.labelPrice && (!amendDuplication.exclusivePrice || amendDuplication.exclusivePrice == 0)">
            <div class="selb">
              <span class="selb-title">标签价格：</span>
              <span>{{ amendDuplication.labelPrice }}</span>
            </div>
          </div>
          <div class="child" v-if="amendDuplication.exclusivePrice && amendDuplication.exclusivePrice != 0">
            <div class="selb">
              <span class="selb-title">尊享价格：</span>
              <span>{{ amendDuplication.exclusivePrice }}</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="btnFlag" class="modifyCart" @click.stop="updateCpoyCart('修改')">确定修改</el-button>
        <!-- <el-button :loading="btnFlag" class="copyCart" @click.stop="updateCpoyCart('复制')">新增商品</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getOptional, getPriceRangeSpot, getPriceRange, getSpotSpecification } from '@/api/detailsApi';
import { modifyCartPublic } from '@/api/cartApi';
import { deepClone } from '@/utils/util';
import { debounce } from '@/utils/index';
import ls from '@/utils/localStorage';
import { cutFilter, clarityColor } from '@/utils/filetrs';
export default {
  props: {
    diamondSelectDialogVisible: Boolean,
    modifyingReplication: {
      type: Object,
      default() {
        return {};
      },
    },
    product: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      optionsList: {
        mainStoneClarity: [],
        mainStoneColour: [],
        gia: [],
        gemNameList: [],
        formatTypes: [],
      },
      amendDuplication: {},
      btnFlag: false,
      handTextureList: [],
      handSizeList: [],
      mainStoneList: [],
      spotList: [],
      flagArray: {
        textureFlag: false,
        mainStoneFlag: false,
        sizeFlag: false,
        colourFlag: false,
        clarityFlag: false,
        giaFlag: false,
        gemNameFlag: false,
        formatTypeFlag: false,
      },
      textureIndex: 0,
      formatTypes: [],
      loading: false,
    };
  },
  filters: {
    cutFilter,
    clarityColor,
  },
  mounted() {
    this.amendDuplication = deepClone(this.modifyingReplication);
    if (this.amendDuplication.spotFlag == 1) {
      this.getSpotOptional();
      this.getPriceRange();
    } else {
      this.getOptional();
    }
  },
  methods: {
    // 金重排序
    mainStoneSort(list) {
      // 1. 将每个区间字符串解析为对象
      const parsedRanges = list?.map((range) => {
        const [start, end] = range.split('-').map(parseFloat);
        return { start, end, range }; // 保留原始字符串以便最后恢复
      });
      // 2. 根据 start 值进行排序
      parsedRanges.sort((a, b) => a.start - b.start);
      // 3. 提取排序后的原始字符串
      return parsedRanges.map((item) => item.range);
    },
    // 规格重新排序
    sortFun(handSizeList) {
      return handSizeList?.sort(function (a, b) {
        return a - b;
      });
    },
    // 版型排序
    sortByChineseSize(list) {
      const orderMap = { 小: 1, 中: 2, 大: 3 };
      return list.slice().sort((a, b) => orderMap[a] - orderMap[b]);
    },
    // 获取可选属性
    getSpotOptional(gender) {
      let obj = {
        styleNumber: this.amendDuplication.styleNumber,
        classify: 2,
        spotFlag: 1,
        gender: this.amendDuplication.d,
      };
      getSpotSpecification(obj).then((res) => {
        if (!gender || gender == '女') {
          this.spotList.splice(0, this.spotList.length);
          res.data.records.forEach((item) => {
            // if (!item.mainStoneClarity == null || item.mainStoneClarity == undefined) {
            //   item.mainStoneClarity = '';
            // }
            // if (item.mainStoneColor == null || item.mainStoneColor == undefined) {
            //   item.mainStoneColor = '';
            // }
            this.spotList.push(item);
          });
          this.getParameter(this.spotList, gender);
        }
      });
    },
    getParameter(spotList, gender) {
      spotList?.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (key && key == 'texture' && item[key] && !this.handTextureList?.some((obj) => obj.value === item[key])) {
            const obj = {
              value: item[key],
              flag: false,
            };
            this.handTextureList?.push(obj);
          }
          if (key && key == 'spec' && item[key] && !this.handSizeList?.some((obj) => obj.value === item[key])) {
            const obj = {
              value: item[key],
              flag: false,
            };
            this.handSizeList?.push(obj);
          }
          if (key && key == 'mainStoneWeight' && item[key] && !this.mainStoneList?.some((obj) => obj.value === item[key])) {
            const obj = {
              value: item[key],
              flag: false,
            };
            this.mainStoneList?.push(obj);
          }
          if (key && key == 'mainStoneClarity' && !this.optionsList.mainStoneClarity?.some((obj) => obj.value === item[key])) {
            const obj = {
              value: item[key],
              flag: false,
            };
            this.optionsList.mainStoneClarity?.push(obj);
          }
          if (key && key == 'mainStoneColor' && !this.optionsList.mainStoneColour?.some((obj) => obj.value === item[key])) {
            const obj = {
              value: item[key],
              flag: false,
            };
            this.optionsList.mainStoneColour?.push(obj);
          }
          if (key && key == 'gia' && item[key] && !this.optionsList.gia?.some((obj) => obj.value === item[key])) {
            const obj = {
              value: item[key],
              flag: false,
            };
            this.optionsList.gia?.push(obj);
          }
          if (key && key == 'assistStoneNameOne' && item[key] && !this.optionsList.gemNameList?.some((obj) => obj.value === item[key])) {
            const obj = {
              value: item[key],
              flag: false,
            };
            this.optionsList.gemNameList?.push(obj);
          }
          if (key && key == 'formatType' && item[key] && !this.optionsList.formatTypes?.some((obj) => obj.value === item[key])) {
            const obj = {
              value: item[key],
              flag: false,
            };
            this.optionsList.formatTypes?.push(obj);
          }
        });
      });
      this.optionsList.formatTypes = this.sortByChineseSize(this.optionsList.formatTypes);
      // 规格重新排序
      this.sortHandSizeList();
      // 主石重新排序
      this.sortMainStoneList();
    },
    // 手寸排序
    sortHandSizeList() {
      this.handSizeList?.sort(function (a, b) {
        return a.value - b.value;
      });
    },
    // 主石排序
    sortMainStoneList() {
      this.mainStoneList?.sort(function (a, b) {
        return a.value - b.value;
      });
    },
    // 版型排序
    sortByChineseSize(list) {
      const orderMap = { 小: 1, 中: 2, 大: 3 };
      return list.slice().sort((a, b) => orderMap[a] - orderMap[b]);
    },
    // 转换数据结构 - 开始
    convertToStandardFormat(list) {
      if (!list) return [];
      return list.map((item) => ({ value: item, flag: false }));
    },
    // 获取可选属性
    getOptional() {
      let obj = {
        styleNumber: this.amendDuplication.styleNumber,
        gender: this.amendDuplication.gender,
        classify: this.amendDuplication.classify,
        spotFlag: this.amendDuplication.spotFlag,
        cartId: this.amendDuplication.id,
        requestFrom: 1,
        sequence: this.amendDuplication.sequence,
      };
      getOptional(obj).then((res) => {
        this.optionsList = { ...this.optionsList, ...res.data };
        this.optionsList.formatTypes = this.convertToStandardFormat(this.optionsList.formatTypes);
        this.formatTypes = this.optionsList.formatTypes;
        this.optionsList.stockQuantity = 0;
        if (this.amendDuplication.isCouples == 2) {
          this.handTextureList = this.convertToStandardFormat(Object.keys(res.data.handSizeMap));
          this.mainStoneList = this.convertToStandardFormat(this.mainStoneSort(Object.keys(Object.values(res.data.handSizeMap)[0])));
          this.handSizeList = this.convertToStandardFormat(this.sortFun(Object.values(Object.values(Object.values(res.data.handSizeMap)[0]))[0]));
        } else {
          this.mainStoneList = this.convertToStandardFormat(
            this.mainStoneSort(Object.keys(Object.values(res.data.couplesMap[this.amendDuplication.gender])[0]))
          );
          this.handTextureList = this.convertToStandardFormat(Object.keys(res.data.couplesMap[this.amendDuplication.gender]));
          this.handSizeList = this.convertToStandardFormat(
            this.sortFun(Object.values(Object.values(res.data.couplesMap[this.amendDuplication.gender])[0])[0])
          );
        }
        this.optionsList.mainStoneClarity = this.convertToStandardFormat(this.optionsList.mainStoneClarity);
        this.optionsList.mainStoneColour = this.convertToStandardFormat(this.optionsList.mainStoneColour);
        this.optionsList.gia = this.convertToStandardFormat(this.optionsList.gia);
        this.optionsList.gemNameList = this.convertToStandardFormat(this.optionsList.gemNameList);
      });
    },
    getSizeRange(value, type, targetType) {
      this.amendDuplication[type] = value;
      if (this.amendDuplication.spotFlag == 2) {
        if (this.amendDuplication.isCouples == '2') {
          if (type === 'texture') {
            this.textureIndex = this.handTextureList.findIndex((item) => item.value == value);
            this.mainStoneList = this.convertToStandardFormat(
              this.mainStoneSort(
                Object.keys(Object.values(this.optionsList.handSizeMap)[this.handTextureList.findIndex((item) => item.value == value)])
              )
            );
            this.handSizeList = this.convertToStandardFormat(
              this.sortFun(Object.values(Object.values(Object.values(this.optionsList?.handSizeMap)[this.textureIndex]))[0])
            );
            this.amendDuplication.mainStone = '';
            this.amendDuplication.ringSize = '';
          }
          if (type === 'mainStone') {
            this.handSizeList = this.convertToStandardFormat(
              this.sortFun(
                Object.values(Object.values(Object.values(this.optionsList?.handSizeMap)[this.textureIndex]))[
                  this.mainStoneList.findIndex((item) => item.value == value)
                ]
              )
            );
            this.amendDuplication.ringSize = '';
          }
        } else {
          if (type === 'texture') {
            this.textureIndex = this.handTextureList.findIndex((item) => item.value == value);
            this.mainStoneList = this.convertToStandardFormat(
              Object.keys(Object.values(this.optionsList?.couplesMap[this.amendDuplication.gender])[this.textureIndex])
            );
            this.handSizeList = this.convertToStandardFormat(
              this.sortFun(Object.values(Object.values(this.optionsList?.couplesMap[this.amendDuplication.gender])[this.textureIndex])[0])
            );
            this.amendDuplication.mainStone = '';
            this.amendDuplication.ringSize = '';
          }
          if (type === 'mainStone') {
            this.handSizeList = this.convertToStandardFormat(
              this.sortFun(
                Object.values(Object.values(this.optionsList?.couplesMap[this.amendDuplication.gender])[this.textureIndex])[
                  this.mainStoneList.findIndex((item) => item.value == value)
                ]
              )
            );
            this.amendDuplication.ringSize = '';
          }
        }
      }
      if (this.DataList.styleNumber == 'TD23XL0001') {
        if (type == 'gemName' && value == '孔雀石') {
          this.optionsList.formatTypes = this.formatTypes.filter((item) => item.value !== '小');
          this.amendDuplication.formatType = '';
        } else if (type == 'gemName' && value != '孔雀石') {
          this.optionsList.formatTypes = this.formatTypes;
        }
      }
      if (this.amendDuplication.spotFlag == 1) {
        this.getPriceRange();
        this.dataProcessing(this.spotList, value, 'amendDuplication', type, targetType);
      } else {
        this.fetchPriceRangeCustom();
      }
    },
    dataProcessing(spotList, item, type, select, targetType) {
      if (select == 'quantity') return;
      const shopArray = [];
      shopArray.splice(0, shopArray.length);
      if (!item && targetType != 'mainStoneClarity' && targetType != 'mainStoneColor') {
        shopArray.push(...spotList);
      } else {
        spotList?.forEach((res) => {
          Object.keys(res).forEach((key) => {
            if (item == res[key] && targetType == key && key != 'accessoryStone' && key != 'assistStoneNameTwo') {
              shopArray.push(res);
            }
          });
        });
      }
      if (shopArray.length == spotList.length) {
        return;
      }
      const textureSet = new Set(shopArray?.map((res) => res.texture) || []);
      this.handTextureList?.forEach((ele) => {
        ele.flag = targetType === 'texture' ? false : !textureSet.has(ele.value);
      });
      const specSet = new Set(shopArray?.map((res) => res.spec) || []);
      this.handSizeList?.forEach((ele) => {
        ele.flag = targetType === 'spec' ? false : !specSet.has(ele.value);
      });
      const mainStoneClaritySet = new Set(shopArray?.map((res) => res.mainStoneClarity) || []);
      this.optionsList.mainStoneClarity?.forEach((ele) => {
        ele.flag = targetType === 'mainStoneClarity' ? false : !mainStoneClaritySet.has(ele.value);
      });
      const mainStoneColorSet = new Set(shopArray?.map((res) => res.mainStoneColor) || []);
      this.optionsList.mainStoneColour?.forEach((ele) => {
        ele.flag = targetType === 'mainStoneColor' ? false : !mainStoneColorSet.has(ele.value);
      });
      const giaSet = new Set(shopArray?.map((res) => res.gia) || []);
      this.optionsList.gia?.forEach((ele) => {
        ele.flag = targetType === 'gia' ? false : !giaSet.has(ele.value);
      });
      const mainStoneWeightSet = new Set(shopArray?.map((res) => res.mainStoneWeight) || []);
      this.mainStoneList?.forEach((ele) => {
        ele.flag = targetType === 'mainStoneWeight' ? false : !mainStoneWeightSet.has(ele.value);
      });
      const formatTypeSet = new Set(shopArray?.map((res) => res.formatType) || []);
      this.optionsList.formatTypes?.forEach((ele) => {
        ele.flag = targetType === 'formatType' ? false : !formatTypeSet.has(ele.value);
      });
      const assistStoneNameOneSet = new Set(shopArray?.map((res) => res.assistStoneNameOne) || []);
      this.optionsList.gemNameList?.forEach((ele) => {
        ele.flag = targetType === 'assistStoneNameOne' ? false : !assistStoneNameOneSet.has(ele.value);
      });
    },
    fetchPriceRangeCustom() {
      this.loading = true;
      const obj = deepClone(this.amendDuplication);
      getPriceRange(obj).then((res) => {
        this.amendDuplication.tradePrice = res.data.tradePrice;
        this.amendDuplication.labelPrice = res.data.labelPrice;
        this.amendDuplication.exclusivePrice = res.data.exclusivePrice;
        this.loading = false;
      });
    },
    // 复制修改商品
    updateCpoyCart(text) {
      let type = '';
      let obj = {};
      if (this.handSizeList.length > 0 && !this.amendDuplication.ringSize) {
        return this.$message({
          message: '请选择规格',
          type: 'warning',
          duration: 500,
        });
      }
      if (!this.amendDuplication.quantity) {
        return this.$message({
          message: '数量不能为0',
          type: 'warning',
          duration: 500,
        });
      }
      if (text === '修改') {
        type = 'put';
      } else {
        obj = {
          productDtoList: [this.amendDuplication],
          shopType: 1,
          type: 2,
          orderPath: 1,
          requestFrom: 1,
          spotFlag: this.amendDuplication.spotFlag,
          purchaseSource: ls.get('coludQuery') ? 0 : 1, //0 云平台产品推荐, 1 其他渠道"
          siteId: ls.get('siteId') || ls.get('userInfo').sysUser?.siteId || '',
        };
        type = 'post';
      }
      modifyCartPublic(text === '修改' ? this.amendDuplication : obj, type).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: text === '修改' ? '修改成功' : '复制成功',
            type: 'success',
            duration: 1500,
          });
          // 修改购物车数据
          this.$emit('updataCart');
          // 关闭弹窗
          this.$emit('onCloseSelectDialog');
        }
      });
    },
    // 实时监听 防抖debounce
    onNative: debounce(
      function (event) {
        if (Number(event.target.value)) {
          if (this.amendDuplication.spotFlag == 2 && event.target.value > 9999) {
            this.amendDuplication.quantity = 9999;
          } else if (this.amendDuplication.spotFlag == 1 && event.target.value > this.optionsList.stockQuantity) {
            this.amendDuplication.quantity = this.optionsList.stockQuantity;
          }
        }
      },
      500,
      true
    ),
    //获取价格范围
    getPriceRange() {
      this.btnFlag = true;
      this.loading = true;
      getPriceRangeSpot(this.amendDuplication)
        .then((res) => {
          this.optionsList.stockQuantity = res.data.stockQuantity;
          this.amendDuplication.tradePrice = res.data.tradePrice;
          this.amendDuplication.labelPrice = res.data.labelPrice;
          this.amendDuplication.exclusivePrice = res.data.exclusivePrice;
          this.btnFlag = false;
          this.loading = false;
        })
        .catch(() => {
          this.btnFlag = false;
          this.loading = false;
        });
    },
    handleClose() {
      this.$emit('onCloseSelectDialog');
    },
  },
};
</script>

<style scoped lang="scss">
.ordinaryModify {
  ::v-deep .el-dialog {
    width: 900px;
  }

  ::v-deep .el-dialog__body {
    padding-top: 0;
  }

  .ordinaryModifyChild {
    display: flex;
  }

  ::v-deep .el-select > .el-input {
    width: 300px;
  }

  .secBox {
    width: 100%;
  }

  .remorkBox {
    margin-top: 25px !important;
  }

  .child {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;

    .selb {
      // height: 40px;
      // line-height: 40px;
      display: flex;
      align-items: center;
      position: relative;
      // width: 400px;

      .el-radio-group {
        // margin-left: 20px;
      }

      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        border-color: #ec9368;
        background: #ec9368;
      }

      ::v-deep .el-radio__input.is-checked + .el-radio__label {
        color: #ec9368;
      }

      span {
        font-size: 14px;
        display: inline-block;
        margin-right: 5px;
        min-width: 70px;
      }
      .selb-title {
        text-align: right;
      }
    }
  }

  ::v-deep .el-dialog__headerbtn .el-dialog__close {
    font-size: 24px;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 5px;
    right: 5px;
  }
}

::v-deep .el-select-dropdown__item {
  padding: 0;
  height: auto;
}

::v-deep .el-select-dropdown__list {
  display: flex;
  width: 300px;
  flex-wrap: wrap;
}

::v-deep .el-input__inner {
  color: #ec9368;
}

::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #fff;
}

::v-deep .el-input-number {
  width: 300px;
}

::v-deep .el-icon-minus {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-icon-plus {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-textarea__inner {
  width: 760px;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep .el-button span {
  font-size: 14px;
}

.modifyCart {
  background: #87ceeb;
  color: #fff;
  border: none;
}

.copyCart {
  background: #ec9368;
  color: #fff;
  border: none;
  margin-left: 20px;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border: 1px solid #ebeef5;
}
.custom {
  .fx {
    position: relative;
    margin: 8px 0;
  }

  .fl {
    display: flex;
    align-items: center;
    position: relative;
  }

  .selectBox {
    ::v-deep .el-popper {
      left: 0 !important;
    }

    .el-scrollbar__view li {
      width: 178px;
    }
  }

  .selectBoxWatch {
    .el-scrollbar__view li {
      min-width: 90px;
    }
  }
  .inchesFix {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    .outStore {
      font-size: 12px;
      position: absolute;
      right: -1px;
      top: -1px;
      color: #999999;
    }
  }
  /deep/ .stockBg .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #c0c4cc;
    background-color: #f2f6fc;
    border-color: #f2f6fc;
  }
  .inchesTips {
    color: red;
    font-size: 12px;
    margin-left: 8px;
  }
  .inchesTips-size {
    color: red;
    font-size: 12px !important;
    margin-left: 8px;
    position: absolute;
    top: 37px;
    left: 20px;
  }
  .material {
    // width: 800px;
    ::v-deep .el-radio-button__inner {
      min-width: 65px;
    }
  }
  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #ec9368;
    border-color: #ec9368;
    box-shadow: none;
  }
  ::v-deep .el-radio-button__inner:hover {
    color: rgb(236, 147, 104);
  }
  ::v-deep .el-radio-button__inner {
    margin: 5px;
    border-left: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  ::v-deep .inchesFix:first-child .el-radio-button__inner {
    margin-left: 0;
  }
  ::v-deep .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
